import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function Reveal({ children, delay = 0, className = "", y = 24 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function SectionHead({ eyebrow, title, sub, testid }) {
    return (
        <Reveal className="max-w-2xl" data-testid={testid}>
            <p className="mb-4 flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.22em] text-fynary-muted">
                <span className="h-1.5 w-1.5 rounded-full bg-fynary-lime" />
                {eyebrow}
            </p>
            <h2 className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
                {title}
            </h2>
            {sub ? <p className="mt-4 text-base leading-relaxed text-fynary-muted sm:text-lg">{sub}</p> : null}
        </Reveal>
    );
}
